<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          description="Especificaciones para la muestra">
          <b-form-textarea
            id="especificaciones"
            v-model="$v.especificaciones.$model" 
            rows="5"
            max-rows="5"
            :state="especificacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="especificacionesFeedback">
            {{ especificacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'BriefMuestraEspecificacionesAdd',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      especificaciones: '',

      noValidar: true,
      especificacionesValidas: null,
      especificacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'especificaciones' || validarTodos) {
        if (this.$v.especificaciones.$error) {
          this.especificacionesValidas = false;
          if (!this.$v.especificaciones.required) {
            this.especificacionesInvalidasMsj = 'Debe ingresar el detalle de las especificaciones para la muestra.';
          } else if (!this.$v.especificaciones.maxLength) {
            this.especificacionesInvalidasMsj = 'Las especificaciones para la muestra sólo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.especificacionesValidas = null;
          this.especificacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            especificaciones: this.especificaciones.trim(),
          }
          this.$emit('registrarEspecificaciones', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarEspecificaciones')
    },
  },
  validations: {
    especificaciones: {
      required,
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
